import { combineReducers } from 'redux'
import quote from './quote'
import group from './group'
import vendor from './vendor'

export default combineReducers({
    quote,
    group,
    vendor
})